import React, { useState } from 'react';
import { PlanActivityTextField } from 'components/TextField/PlanActivityTextField';
import { STEPS } from 'models/exercises/IExercisePlan';
import { IStep, PageContents } from './StrategyExercisePlan';
import { StyledSolutionArea, AddRowButton } from './StrategyExercisePlan.styled';

interface IStepFiveProps extends IStep {
  setPlanSteps: React.Dispatch<React.SetStateAction<string[]>>
}

export const StepFivePage: React.FC<IStepFiveProps> = ({ content, setStep, setPlanSteps, handleError }) => {
  const [fields, setFields] = useState<string[]>(['', '', '', '']);
  const NUM_OF_SOLUTIONS_NEEDED = 2;
  const errorMessage = 'Fill in at least 2 steps to progress';

  const handleFieldChange = (index: number) => (newValue: string) => {
    const updatedFields = [...fields];
    updatedFields[index] = newValue;
    setFields(updatedFields);
  };

  const addNewField = () => {
    setFields([...fields, '']);
  };

  const onCtaClick = () => {
    const filledFields = fields.filter((field) => field.trim() !== '');

    if (filledFields.length < NUM_OF_SOLUTIONS_NEEDED) {
      handleError && handleError({ isError: true, errorMessage: errorMessage });
      return;
    }

    handleError && handleError({ isError: false, errorMessage: '' })
    setPlanSteps(filledFields);
    setStep(STEPS.STEP_SIX); 
  };
  
  return (
    <React.Fragment>
      <PageContents content={content} onCtaClick={onCtaClick}>
        <StyledSolutionArea>
          {fields.map((field, index) => (
            <PlanActivityTextField onChange={handleFieldChange(index)} fieldNumber={`${index + 1}.`} placeholder={''} initialValue={field} key={index}/>
          ))}
        </StyledSolutionArea>
        <AddRowButton onClick={addNewField}>+ another row</AddRowButton>
      </PageContents>
    </React.Fragment>
  )
}